import { ActionType, getType } from 'typesafe-actions';
import { IValueAddedTax } from '../../../@types/model/masterData/valueAddedTax/valueAddedTax';
import actions from './actions';

type MasterDataValueAddedTaxActionType = ActionType<typeof actions>;

export interface IMasterDataValueAddedTaxState {
    valueAddedTaxes : Array<IValueAddedTax>;
    isLoading : boolean;
}
const initialState = {
    valueAddedTaxes: [],
    isLoading: false,
};

export default function masterDataValueAddedTaxReducer(state : IMasterDataValueAddedTaxState = initialState, action : MasterDataValueAddedTaxActionType) : IMasterDataValueAddedTaxState {
    switch (action.type) {
        case getType(actions.set):
            return { ...state, valueAddedTaxes: action.payload };
        case getType(actions.setLoading):
            return { ...state, isLoading: action.payload };
        default:
            return state;
    }
}
